/**
 * Testimonials Scroll Animation
 * GSAP-powered vertical scroll with smooth hover slow-down
 */

import { gsap } from 'gsap';

export function initTestimonialsScroll() {
  const columns = document.querySelectorAll('.testimonials__column');

  if (columns.length === 0) return;

  columns.forEach((column, index) => {
    const track = column.querySelector('.testimonials__track');
    if (!track) return;

    // Calculate the height to scroll (50% for seamless loop)
    const scrollDistance = track.scrollHeight / 2;

    // Different speeds and directions for each column
    const isUp = column.classList.contains('testimonials__column--up');
    const baseDuration = isUp ? 25 : 30;
    const slowDuration = 150; // Really slow on hover

    // Create the infinite scroll animation
    const tl = gsap.timeline({ repeat: -1 });

    if (isUp) {
      // Scroll up: start at 0, go to -50%
      gsap.set(track, { y: 0 });
      tl.to(track, {
        y: -scrollDistance,
        duration: baseDuration,
        ease: 'none',
      });
    } else {
      // Scroll down: start at -50%, go to 0
      gsap.set(track, { y: -scrollDistance });
      tl.to(track, {
        y: 0,
        duration: baseDuration,
        ease: 'none',
      });
    }

    // Store reference to timeline on the element
    column._scrollTimeline = tl;
    column._baseDuration = baseDuration;
    column._slowDuration = slowDuration;

    // Hover handlers for smooth speed transition
    column.addEventListener('mouseenter', () => {
      // Smoothly transition to slow speed
      gsap.to(tl, {
        timeScale: baseDuration / slowDuration,
        duration: 0.8,
        ease: 'power2.out',
      });
    });

    column.addEventListener('mouseleave', () => {
      // Smoothly transition back to normal speed
      gsap.to(tl, {
        timeScale: 1,
        duration: 0.8,
        ease: 'power2.out',
      });
    });
  });
}
